import { CRC32 } from "../utils/CRC32.js";

export class QURLGenerator {
  constructor() {
    this.fWSMgr = null;

    this.fLinkType = null;
    this.fUserID = "";

    this.fLaunchMode = null;
    this.fZoomSelection = null;
    this.fEnablemw = false;
    this.fIncludeProfPan = true;
    this.fIncludeSCPan = true;
    this.fSAML = false;
    this.fEntityID = null;
    this.fDivision = null;
    this.fTopBox = null;
    this.fFilename = null;
    this.fDirectory = null;
    this.fAddParams = null;
    this.fIncludeColor = false;
    this.fCurTab = "None";
    this.fEnableFileMgr = true;
    this.fEnableExcel = true;
    this.fEnablePublish = true;

    this.fLaunchChart = null;
    this.fLaunchPlan = null;
    this.fUIProfile = null;
    this.fLaunchType = "Master Chart";
    this.fDoIFrame = false;
    this.fResult = null;
    this.fIsLegacy = false;
    this.fLinkUser = "";
  }

  InitURLParams(wsMgr) {
    this.fWSMgr = wsMgr;
    this.fResult = "";
    var urldefs = localStorage.getItem("urlgen");
    if (urldefs != null) {
      var jobj = JSON.parse(urldefs);
      this.fLinkType = jobj.linkType;
      // this.fOnLaunch = jobj.onLaunch;
      this.fDirectory = jobj.directory;
      this.fFilename = jobj.fileName;
      this.fLaunchMode = jobj.launchMode;
      this.fLaunchSubMode = jobj.launchSubMode;
      this.fLaunchChart = jobj.launchChart;
      this.fLaunchType = jobj.launchType;
      if (this.fLaunchMode === "Planning") this.fLaunchType = "Plan";
      else if (this.fLaunchMode == "Workbench") this.fLaunchType = "Chart Document";
      else if (this.fLaunchType == null)
        this.fLaunchType = this.fLaunchChart ? "Master Chart" : "Chart Document";
      this.fLaunchPlan = jobj.launchPlan;
      this.fZoomSelection = jobj.zoom;
      this.fIncludeProfPan = jobj.profPanel;
      this.fUIProfile = jobj.uiprofile;
      this.fIncludeSCPan = jobj.subchartPanel;
      this.fEnablemw = jobj.mouseWheel;
      //localstorage.setItem('color',urlParams.fBackgroundColor);
      this.fDivision = jobj.division;
      this.fTopBox = jobj.topBox;
      this.fAddParams = jobj.additionalParams;
      this.fSAML = jobj.enableSAML;
      this.fEntityID = jobj.entityID;
      this.fCurTab = jobj.tab;
      this.fEnableFileMgr = jobj.fileMgr;
      this.fEnableExcel = jobj.excel;
      this.fEnablePublish = jobj.publish;
      this.fIncludeColor = jobj.includecolor;
      this.fBackGroundColor = jobj.color;
      this.fIsLegacy = jobj.islegacy == null ? false : jobj.islegacy;
      this.fLinkUser = jobj.linkuser == null ? "" : jobj.linkuser;
    } else {
      this.fLinkType = "public";
      this.fLaunchMode = "Viewer";
      this.fZoomSelection = "100";
      this.fCurTab = "None";
      this.fIncludeProfPan = true;
      this.fIncludeSCPan = true;
      this.fEnableFileMgr = true;
      this.fEnableExcel = true;
      this.fEnablePublish = true;
      this.fEnablemw = false;
      this.fEntityID = "";
      this.fDivision = "";
      this.fTopBox = "";
      this.fFilename = "";
      this.fDirectory = "";
      this.fAddParams = "";
      this.fBackGroundColor = "FFFFFF";
      this.fIncludeColor = false;
    }
    var docMgr = this.fWSMgr.GetDocMgr();
    var fileName = "";
    var directory = "";
    var sourceFile = this.GetFilename();
    var sourceDir = this.GetDirectory();

    var curFileName = docMgr.GetFileName(true);
    var curDirName = docMgr.GetFileDirectory();

    if (sourceFile) {
      fileName = sourceFile;
    } else if (curFileName && !this.fWSMgr.GetDoc().IsServerChart()) {
      fileName = curFileName;
    }

    if (sourceDir) directory = sourceDir;
    else if (curDirName && !this.fWSMgr.GetDoc().IsServerChart()) directory = curDirName;

    this.SetFilename(fileName);
    this.SetDirectory(directory);
  }

  GetLinkType() {
    return this.fLinkType;
  }

  SetLinkType(linkType) {
    this.fLinkType = linkType;
  }

  GetLaunchMode() {
    return this.fLaunchMode;
  }

  SetLaunchMode(launchMode) {
    this.fLaunchMode = launchMode;
  }

  GetZoomSelection() {
    return this.fZoomSelection;
  }

  SetZoomSelection(zoom) {
    this.fZoomSelection = zoom;
  }

  GetLinkUser() {
    return this.fLinkUser;
  }

  SetLinkUser(userID) {
    this.fLinkUser = userID;
  }

  GetDirectory() {
    return this.fDirectory;
  }

  SetDirectory(directory) {
    this.fDirectory = directory;
  }

  GetFilename() {
    return this.fFilename;
  }

  SetFilename(fileName) {
    this.fFilename = fileName;
  }

  GetProfPan() {
    return this.fIncludeProfPan;
  }

  SetProfPan(profPan) {
    this.fIncludeProfPan = profPan;
  }

  GetSCPan() {
    return this.fIncludeSCPan;
  }

  SetSCPan(scPan) {
    this.fIncludeSCPan = scPan;
  }

  GetFileMgr() {
    return this.fEnableFileMgr;
  }

  SetFileMgr(fileMgr) {
    this.fEnableFileMgr = fileMgr;
  }

  GetExcel() {
    return this.fEnableExcel;
  }

  SetExcel(excel) {
    this.fEnableExcel = excel;
  }

  GetPublish() {
    return this.fEnablePublish;
  }

  SetPublish(publish) {
    this.fEnablePublish = publish;
  }

  GetMW() {
    return this.fEnablemw;
  }

  SetMW(mouseWheel) {
    this.fEnablemw = mouseWheel;
  }

  GetDivision() {
    return this.fDivision;
  }

  SetDivision(division) {
    this.fDivision = division;
  }

  GetTopBoxID() {
    return this.fTopBox;
  }

  SetTopBoxID(topBoxID) {
    this.fTopBox = topBoxID;
  }

  GetSAML() {
    return this.fSAML;
  }

  SetSAML(saml) {
    this.fSAML = saml;
  }

  GetIFrame() {
    return this.fDoIFrame;
  }

  SetIFrame(set) {
    this.fDoIFrame = set;
  }

  GetAddParams() {
    return this.fAddParams;
  }

  SetAddParams(addParams) {
    this.fAddParams = addParams;
  }

  ValidateAddParams(addParams) {
    // Checks if params follow format {non-empty field}={non-empty value}&{...field}={value}
    // Checks the latest params or the one that is saved.
    var paramsInput = addParams || this.fAddParams;
    var paramsList = paramsInput.split("&");
    this.fEnableLinkButtons = true;
    // Empty params is not an invalid response.
    if (paramsList.length == 1 && paramsList[0].length == 0) return this.fEnableLinkButtons;
    for (var params of paramsList) {
      var param = params.split("=");
      if (
        param.length != 2 ||
        param.some(function (ele) {
          return ele.length == 0;
        })
      )
        this.fEnableLinkButtons = false;
    }
    return this.fEnableLinkButtons;
  }

  GetEntityID() {
    return this.fEntityID;
  }

  SetEntityID(entityID) {
    this.fEntityID = entityID;
  }

  GetBackGroundColor() {
    return this.fBackGroundColor;
  }

  SetBackgroundColor(backgroundColor) {
    this.fBackGroundColor = backgroundColor;
  }

  GetIncludeColor() {
    return this.fIncludeColor;
  }

  SetIncludeColor(includeColor) {
    this.fIncludeColor = includeColor;
  }

  GetTab() {
    return this.fCurTab;
  }

  SetTab(tab) {
    this.fCurTab = tab;
  }

  GetLevels() {
    return this.fLevels;
  }

  SetLevels(levels) {
    this.fLevels = levels;
  }

  GetView() {
    return this.fView;
  }

  SetView(view) {
    this.fView = view;
  }

  GetLaunchChart() {
    return this.fLaunchChart;
  }

  SetLaunchChart(chart) {
    this.fLaunchChart = chart;
  }

  SetLaunchDoc(doc) {
    var directory = "";
    var filename = "";
    if (doc) {
      directory = doc.directory;
      filename = doc.filename;
    }
    this.SetDirectory(directory);
    this.SetFilename(filename);
  }

  SetLaunchPlan(aPlan) {
    this.fLaunchPlan = aPlan;
  }

  GetUIProfile() {
    return this.fUIProfile;
  }

  SetUIProfile(profile) {
    this.fUIProfile = profile;
  }

  GetLaunchType() {
    return this.fLaunchType;
  }

  SetLaunchType(type) {
    this.fLaunchType = type;
  }

  AddParam(currentUrl, value, paramName) {
    var s = "";
    if (value == null || value.length == 0) return s;
    if (currentUrl.length > 0) s = "&";

    s += paramName + "=" + encodeURIComponent(value);

    return s;
  }

  TestURL(curOrg) {
    this.GenerateURL(curOrg);
    window.open(this.fResult);
    return this.fResult;
  }

  GetLinkOrigin() {
    var origin = window.location.origin;

    return origin;
  }

  GetLinkStart(linkType, SAML) {
    var start = "/serverside/api/secureopenchart?";

    switch (linkType) {
      case "public":
      case "restricted":
      default:
        break;
      case "private":
        if (SAML) {
          start = "/saml/sso_endpoint?entityID=";
          var entityid = this.GetEntityID();
          if (entityid == "") return false;
          start += entityid + "&";
        } else start = "//?";
        break;
    }
    return start;
  }

  GetLinkDL(linkType, isLegacy, curOrg) {
    //TODO- can probably break this into further sub methods
    var profPan = this.GetProfPan();
    var subchartPan = this.GetSCPan();
    var fileMgr = this.GetFileMgr();
    var excel = this.GetExcel();
    var publish = this.GetPublish();

    var startdiv = this.GetDivision();
    var topbox = this.GetTopBoxID();
    var mousewheelenable = this.GetMW();
    var parameters = this.GetAddParams();
    var includeColor = this.GetIncludeColor();
    var zoomLevel = this.GetZoomSelection();

    var launchChart = this.GetLaunchChart();
    var launchType = this.GetLaunchType();
    var launchMode = this.GetLaunchMode();

    var uiProfile = this.GetUIProfile();

    var directory = this.GetDirectory();
    var filename = this.GetFilename();

    var theURL = "";

    var color = this.GetBackGroundColor();
    if (color) color = color.replace("#", "");

    if (linkType == "public" || (linkType == "restricted" && !isLegacy)) {
      var username = this.GetLinkUser();
      if (!username) return false;
      theURL += this.AddParam(theURL, username, "user");
      theURL += this.AddParam(theURL, curOrg, "org");
    }

    theURL += this.AddParam(theURL, launchMode, "mode");
    //theURL += this.AddParam(theURL,zoomLevel,"zoom");

    if (uiProfile == null) {
      excel = !!excel;
      theURL += this.AddParam(theURL, excel.toString(), "excel");

      if (launchMode == "Workbench") {
        // anything that launches us to workbench
        fileMgr = !!fileMgr;
        theURL += this.AddParam(theURL, fileMgr.toString(), "filemgr");
      }
      publish = !!publish;
      theURL += this.AddParam(theURL, publish.toString(), "publish");

      if (!profPan && subchartPan) theURL += this.AddParam(theURL, "Profile", "hidetabs");
      else if (!profPan && !subchartPan)
        theURL += this.AddParam(theURL, "Profile,Subcharts", "hidetabs");
      else if (profPan && !subchartPan) theURL += this.AddParam(theURL, "Subcharts", "hidetabs");

      mousewheelenable = !mousewheelenable;
      theURL += this.AddParam(theURL, mousewheelenable, "mwoff");
    } else if (uiProfile !== "default") theURL += this.AddParam(theURL, uiProfile, "launchprofile");

    if (includeColor) theURL += this.AddParam(theURL, color, "bkgrnd");
    else if (this.GetIFrame()) theURL += this.AddParam(theURL, "FFFFFF", "bkgrnd");

    if (topbox.length > 0) theURL += this.AddParam(theURL, topbox, "topboxid");

    if (launchType === "Master Chart") {
      var chartID = launchChart ? launchChart["chartID"] : this.fWSMgr.fOrgInfo.defaultchart;
      theURL += this.AddParam(theURL, chartID, "chartID");
      var levels = this.GetLevels();
      if (levels) theURL += this.AddParam(theURL, levels.toString(), "levels");
      var view = this.GetView();
      if (view) theURL += this.AddParam(theURL, view.toString(), "view");
    } else if (launchType === "Plan") {
      var planID = null;
      if (this.fLaunchPlan) planID = this.fLaunchPlan["ID"];
      theURL += this.AddParam(theURL, planID, "launchPlanID");
      var levels = this.GetLevels();
      if (levels) theURL += this.AddParam(theURL, levels.toString(), "levels");
      var view = this.GetView();
      if (view) theURL += this.AddParam(theURL, view.toString(), "view");
    } else {
      var tabValue = this.GetTab();
      if (tabValue != "None") theURL += this.AddParam(theURL, tabValue, "tab");

      if (startdiv.length > 0) theURL += this.AddParam(theURL, startdiv, "division");

      if (filename == null || filename == "" || filename == "<not set>") return false;
      else theURL += this.AddParam(theURL, filename, "file");
      if (directory == null || directory == "" || directory == "<not set>") return false;
      else theURL += this.AddParam(theURL, directory, "directory");
    }

    if (parameters.length > 0) {
      if (parameters.charAt(0) == "&") theURL += parameters;
      else {
        parameters = "&" + parameters;
        theURL += parameters;
      }
    }

    return theURL;
  }

  GenerateURL(curOrg) {
    //TODO: If we hit something invalid, return false
    var linkType = this.GetLinkType();
    var isLegacy = this.fIsLegacy;
    var SAML = this.GetSAML();

    var origin = this.GetLinkOrigin();

    var start = this.GetLinkStart(linkType, SAML);

    var theURL = this.GetLinkDL(linkType, isLegacy, curOrg);

    if (!start || !origin || !theURL || !this.ValidateAddParams()) return false;

    var crc = CRC32.str(theURL);

    theURL += this.AddParam(theURL, crc, "crc");

    var dl = "dl=" + window.btoa(theURL);

    var fullStr = origin + start + dl;
    if (this.GetIFrame()) {
      var iFrameFirst = '<iframe src="';
      var iFrameLast =
        '" style="border:0px #ffffff none;" name="myiFrame" scrolling="no" frameborder="1" marginheight="0px" marginwidth="0px" height="400px" width="600px" allowfullscreen></iframe>';
      fullStr = iFrameFirst + fullStr + iFrameLast;
    }

    this.fResult = fullStr;
    return fullStr;
  }
}
